module.exports = __webpack_public_path__ + "static/img/logo_fxhao.e3b49f11.png";